<template>
  <div class="glod-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="goldOperation('add')" class="add-input">+新增配置</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" fixed min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.name || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coins" label="充值获币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.coins || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.price/100 || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="couponDesc" label="优惠描述" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.couponDesc || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveVipDays" label="赠送vip天数" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveVipDays || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="louFengUnlockTimes" label="楼凤解锁次数" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.louFengUnlockTimes || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveGameCoin" label="赠送游戏金币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveGameCoin || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="notFirst" label="非首充赠送" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.notFirst" active-text="开启" inactive-text="关闭" disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" active-text="上架" inactive-text="下架" disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="goldOperation('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeGold(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <gold-action ref="goldAction" @handlerGoldList="getGoldList('status')"></gold-action>
  </div>
</template>

<script>
import API from '@/api'
import GoldAction from "./components/goldAction"
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
    }
  },
  components: {
    GoldAction
  },
  created() {
    // this.$store.dispatch('setRouterTag', { router: '/administrators', routerName: "系统管理员" })
    this.getGoldList()
  },
  methods: {
    // 请求金币列表
    getGoldList() {
      this.loading = true;
      API.getGameGoldList().then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除金币配置
    removeGold(id) {
      this.$confirm('您确定要删除当前金币配置吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delGameGold({ ids: [id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除金币配置成功',
                type: 'success'
              })
              this.getGoldList()
            } else {
              this.$message.error('删除金币配置失败')
            }
          })
        })
        .catch(() => { });
    },
    // 新增、编辑操作
    goldOperation(type, data) {
      this.$refs.goldAction.open(type, data)
    }
  }
}
</script>

<style lang="scss">
.gold-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
